import React, { FC } from 'react'

import { IconPlayArrowProps } from './IconPlayArrow.types'
import * as Styled from './styles/IconPlayArrow.style'

import { nonThemeableRules } from '../../ruleSet'

const IconPlayArrow: FC<IconPlayArrowProps> = ({
  size = nonThemeableRules.defaultSize as number as IconPlayArrowProps['size'],
  isResponsive = false,
}: IconPlayArrowProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive}>
      <svg fill='none' viewBox='0 0 48 48' xmlns='http://www.w3.org/2000/svg'>
        <path
          d='M13 9.428v29.02A2.52 2.52 0 0 0 15.377 41a2.465 2.465 0 0 0 1.578-.5c.05-.04.348-.25.348-.25l18.564-13.802.546-.41a2.416 2.416 0 0 0-.018-4.048l-.528-.397-18.5-13.763c-.77-.632-1.727-1.095-2.842-.605a2.637 2.637 0 0 0-1.5 2.433v.195'
          stroke='#E60000'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
      </svg>
    </Styled.IconWrapper>
  )
}

export default IconPlayArrow
